import { useEffect, useId } from 'react';
const Locks = new Set();
export function useScrollLock(active = false) {
    const id = useId();
    useEffect(() => {
        if (active) {
            Locks.add(id);
            document.documentElement.dataset.mollieUiScrollLock = 'true';
        }
        else {
            Locks.delete(id);
            if (Locks.size === 0) {
                document.documentElement.dataset.mollieUiScrollLock = 'false';
            }
        }
        return () => {
            Locks.delete(id);
            if (Locks.size === 0) {
                document.documentElement.dataset.mollieUiScrollLock = 'false';
            }
        };
    }, [active, id]);
}
//# sourceMappingURL=useScrollLock.js.map